import { MapChart } from 'nswidgets/src/components/map/map-chart'
import React, { useCallback } from 'react'

import { useSideBySideChartContext } from '../../contexts/side-by-side.context'

export const MapBlockChart = function (props) {
  const sideBySideChartContext = useSideBySideChartContext() || {}

  const onZoomIn = useCallback((zoom) => {
    if (sideBySideChartContext.chartMirrorData) {
      sideBySideChartContext.setChartMirrorDataValue('zoom', zoom)
    }
  })

  const onZoomOut = useCallback(() => {
    if (sideBySideChartContext.chartMirrorData) {
      sideBySideChartContext.setChartMirrorDataValue('zoom', undefined)
    }
  })

  return (
    <MapChart
      zoomState={props.splitChart ? (sideBySideChartContext && sideBySideChartContext.chartMirrorData && sideBySideChartContext.chartMirrorData.zoom) : undefined}
      onZoomIn={props.splitChart && onZoomIn}
      onZoomOut={props.splitChart && onZoomOut}
      {...props}
    />
  )
}
